<template>
  <ClientOnly>
    <div style="text-align: center; margin-top: 20px; user-select: none">
      <span>{{ msg }}</span>
      <a v-if="retry" class="btn" @click="start">重试</a>
    </div>
  </ClientOnly>
</template>

<script setup lang="ts">
const msg = ref('系统登录中...')
const retry = ref(false)
const requestURL = useRequestURL()
const { setSession } = useChangeUser()

const getToken = () => {
  return window.document.cookie.replace(
    /(?:(?:^|.*;\s*)hwork_token_prod\s*=\s*([^;]*).*$)|^.*$/,
    '$1'
  )
}

interface LoginData {
  key: string
  user_id: number
  retInfo: string
  session_id: string
}

async function sendToken(token: string) {
  const data = await $fetch<{
    data: LoginData
    error_code: number
    error_reason: string
  }>('https://apis.youyan.xyz/haier/login/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ token }),
    onResponse({ response }) {
      // 后端接口返回500状态码，只能这里处理
      if (response._data.error_code) {
        msg.value = response._data?.data?.retInfo
        retry.value = true
      }
    },
  })

  if (!data) {
    return
  }

  if (!data.error_code) {
    await setSession(data.data)
    location.replace(requestURL.origin + '/platform')

    return
  }

  msg.value = data.data.retInfo
  retry.value = true
}

function start() {
  retry.value = false
  msg.value = '系统登录中...'
  const token = getToken()
  if (!token) {
    msg.value =
      '您暂未获得速影平台权限。如需申请，请在速影应用平台账号开通中登记，权限开通后您会收到邮件通知！'
    retry.value = false
    return
  }
  sendToken(token)
}

onBeforeMount(() => {
  start()
})
</script>
<style lang="scss">
.btn {
  margin-left: 6px;
  color: blue;
  cursor: pointer;
  text-decoration: underline;
  &:active {
    color: red;
  }
}
</style>
